<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view></router-view>
  </div>
</template>

<style src='./assets/css/ace.css'></style>
<style src='./assets/css/style.css'></style>
<script>
import Nav from "./views/Nav.vue";
export default {
  components: {
    "nav-bar": Nav
  }
};
</script>
